import { render, staticRenderFns } from "./ModeloDocumentoListagem.vue?vue&type=template&id=51b5f4c3&scoped=true"
import script from "./ModeloDocumentoListagem.vue?vue&type=script&lang=js"
export * from "./ModeloDocumentoListagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b5f4c3",
  null
  
)

export default component.exports